import { useContext, useEffect, useRef } from 'react'
import { AppState } from 'react-native'
import { FuelContext } from '../context/Logistics/fuel/FuelProvider'
import { useHasInternet } from '../hooks/useHasInternet'
import { useSendFuelRecord } from '../modules/Logistics/FuelReceptions/hooks/useSendFuelRecord'

export const FuelAutoSend = () => {
  const { getDataByState } = useContext(FuelContext)
  const { isConnected } = useHasInternet()
  const { handleSend, isLoading } = useSendFuelRecord({})

  const isConnectedRef = useRef(isConnected)
  const isLoadingRef = useRef(isLoading)

  useEffect(() => {
    isConnectedRef.current = isConnected
  }, [isConnected])
  useEffect(() => {
    isLoadingRef.current = isLoading
  }, [isLoading])

  const trySend = () => {
    if (isConnectedRef.current !== true || isLoadingRef.current) return
    const pending = getDataByState('pending')
    if (pending.length > 0) handleSend(pending)
  }

  useEffect(() => {
    if (isConnected === true) trySend()
  }, [isConnected])

  useEffect(() => {
    const subscription = AppState.addEventListener('change', (nextState) => {
      if (nextState === 'active') trySend()
    })
    return () => subscription.remove()
  }, [])

  return null
}
